// extracted by mini-css-extract-plugin
export var arrows = "_3l-5";
export var decrementer = "_3l-9";
export var disabled = "_3l-3";
export var error = "_3l-1";
export var hiddenText = "_3l-a";
export var incrementer = "_3l-8";
export var input = "_3l-7";
export var inputWrapper = "_3l-0";
export var readonly = "_3l-2";
export var regular = "_3l-6";
export var small = "_3l-4";